export function getContentQuestion (question?: string) {
    if (typeof question !== 'string') {
        return question
    }
    if (!question) {
        return ''
    }
    try {
        if (question.startsWith('[') || question.startsWith('{')) {
            const parsedQuestion = JSON.parse(question)
            if (Array.isArray(parsedQuestion)) {
                return parsedQuestion.join(',\n')
            } else {
                return Object.entries(parsedQuestion).map(([ key, value ]) => `${key}: ${value}`).join(',\n ')
            }
        }
        return question.replace(/\\n/g, '\n')
    } catch (e) {
        return question
    }
}
